import React, { Component } from 'react';
import { Doughnut } from 'react-chartjs-2';

class ProgressChart extends Component {
  progressPercentage() {
    if (!this.props.progressPercentage) {
      return 0;
    }
    return Math.abs((this.props.progressPercentage).toFixed(1) - (this.props.progressPercentage).toFixed(0)) < 0.1 ?
      (this.props.progressPercentage).toFixed(0) : (this.props.progressPercentage).toFixed(1)
  }

  render() {
    const {
      progressPercentage,
      ...otherProps
    } = this.props;

    const data = {
      datasets: [
        {
          data: [Math.min(progressPercentage, 100), Math.max(100 - progressPercentage, 0)],
          backgroundColor: ['#00FA96', '#969696'],
          borderWidth: 0
        }
      ]
    };

    const options = {
      cutoutPercentage: 80,
      responsive: true,
      tooltips: {
        enabled: false
      },
      hover: {
        mode: null
      },
      layout: {
        padding: {
          left: 0,
          right: 0,
          top: 0,
          bottom: 10
        }
      }
    };

    const progressText = {
      beforeDraw: (chart) => {
        const {
          width,
          height,
          ctx
        } = chart.chart;
        ctx.restore();

        ctx.font = `600 ${width / 6}px Open Sans`;
        ctx.textBaseline = 'middle';
        var text = `${this.progressPercentage()}%`,
          textX = Math.round((width - ctx.measureText(text).width) / 2),
          textY = height / 2;
        ctx.fillStyle = '#969696';
        ctx.fillText(text, textX, textY);

        ctx.save();
      }
    };

    return <Doughnut data={data} options={options} plugins={[progressText]} {...otherProps} />;
  }
}

export default ProgressChart;



// WEBPACK FOOTER //
// ./src/containers/partials/progress-chart.js